import { CommonModule, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PropertyDto, PropertyType } from '@workspace/data-types';
import { EtxeEnumDisplayPipe } from '../../../../pipes/etxe-enum-display.pipe';

@Component({
  selector: 'etxe-property-key-infos-display',
  imports: [CommonModule, DecimalPipe, MatIconModule, MatTooltipModule, EtxeEnumDisplayPipe],
  templateUrl: './key-infos-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyKeyInfosDisplayComponent {
  PropertyType = PropertyType;
  property = input.required<PropertyDto>();

  pricePerSquareMeter = computed(() => {
    const price = this.property().financials?.sellingPriceCents;
    const surface = this.property().keyInfo?.surface?.habitable;
    if (!price || !surface || surface <= 0) return null;
    return Math.round(price / 100 / surface);
  });
}
